export default "<div class=\"template\">\n    Error 404 <br />\n    Something has gone wrong!\n</div>";